// "Replace your reply?" asks only when the person edited the reply
// (2026-11-02, Jenn; docs/contact-view.md "Replace your reply?").
//
// Every place that replaces the reply box with a template (a Return Status
// stage and its date, the house template after Process, the replacement /
// refund switch, the correct part's reply, Other Actions' paste, the reply
// following the agent's own steps) asks first only when the box differs from
// what CXHub last put in it (the panel's appliedDraftRef, the same baseline
// as isDraftDirty()). A box that still holds exactly what CXHub put there
// (the AI or agent draft, a template CXHub filled, an earlier paste) is
// replaced without asking, and a short line under the reply says so.
//
// Differences that are whitespace only, or only the signature, are not
// edits; nor is an empty or signature-only box (nothing of the person's to
// lose). An edit undone back to the original text is not an edit. Pure: no
// React, so node --test covers it.

import { isSignatureOnlyReply } from '@cxhub/shared'

// The text as compared: tags and &nbsp; read as spaces, runs of whitespace
// collapsed, trimmed.
export function normalizeReplyText(value) {
  return String(value ?? '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;| /g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

function withoutSignature(text, signature) {
  if (!signature) return text
  if (text === signature) return ''
  return text.endsWith(signature) ? text.slice(0, -signature.length).trim() : text
}

// Whether the person edited the reply since CXHub last set it. box: the
// reply box now. baseline: the box as CXHub last set it. signature: the
// box's signature seed (signature-only differences are not edits).
export function isReplyEdited({ box = '', baseline = '', signature = null } = {}) {
  if (isSignatureOnlyReply(box, signature)) return false
  const sig = normalizeReplyText(signature)
  return withoutSignature(normalizeReplyText(box), sig) !== withoutSignature(normalizeReplyText(baseline), sig)
}

// The line under the reply after a replace that did not ask, for a few
// seconds. title: the template's title, when known. own: the reply put back
// is the person's own from the path they left (the resolution switch).
export function replyReplacedNote({ title = null, own = false } = {}) {
  if (own) return 'Reply switched back to the earlier reply for this choice'
  return title ? `Reply updated to the "${title}" template` : 'Reply updated to the template'
}

// How long the line shows.
export const REPLY_REPLACED_NOTE_MS = 6000
